import { apiDownloadBlob } from './client.js';

/**
 * Bank-export download (bank-export feature). GETs the generic CSV for one
 * currency and triggers a browser save. On a 422 (missing bank info) the
 * underlying apiDownloadBlob throws an ApiError whose `.body` carries
 * `{ error, message, missingEmployees }` — the caller surfaces the modal.
 */
export async function downloadBankFile(runId: string, currency: string): Promise<void> {
  const { blob, filename } = await apiDownloadBlob(
    `/v1/payroll-runs/${encodeURIComponent(runId)}/bank-file?currency=${encodeURIComponent(currency)}`,
    `lumohr-bank-${currency}.csv`,
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
